import React, { useState } from 'react'
import { MaskingRuleClause } from '../../../data/gql-gen/questionnaire/graphql'
import { DisplayLogicDraft } from '../../../data/model/audienceQuestionLogic'
import { Operator } from '../../../data/model/common'
import DisplayLogicSummaryBox from '../../Questionnaire/DisplayLogicHeader/DisplayLogicSummaryBox'
import { questionTextTo } from '../../Questionnaire/DisplayLogicHeader/util'
import DialogScreenerDisplayLogic from './DialogScreenerDisplayLogic'
import { useScreenerDisplayLogic } from './screenerDisplayLogic.hooks'
import { hasDisplayLogic } from './screenerDisplayLogic.utils'

interface Props {
  questionId: string
}

const DisplayLogicSummary: React.FC<Props> = ({ questionId }: Props) => {
  const [open, setOpen] = useState(false)
  const {
    label,
    isTargeting,
    hasInvalidSource,
    logic,
    draft,
    questions,
    save,
    remove
  } = useScreenerDisplayLogic(questionId)

  if (!hasDisplayLogic(logic)) return null

  const onSave = (next: DisplayLogicDraft) => {
    setOpen(false)
    void save(next)
  }

  return (
    <>
      <DisplayLogicSummaryBox
        hasError={hasInvalidSource}
        onEdit={() => setOpen(true)}
        onRemove={() => void remove()}
      >
        <>
          {draft.rows.map((row, index) => {
            const question = questions.find(
              (q) => q.questionId === row.questionId
            )

            return (
              <div
                className="fd-grid fd-item"
                // biome-ignore lint/suspicious/noArrayIndexKey: rows are positional and have no stable id
                key={index}
              >
                {questionTextTo({
                  questionText: question?.label ?? 'a deleted question',
                  roTexts: row.responseOptionIds.map(
                    (id) =>
                      question?.responseOptions.find(
                        (option) => option.id === id
                      )?.value
                  ),
                  negationText: row.negated ? 'is NOT' : 'is',
                  operator:
                    index === 0
                      ? undefined
                      : draft.operator === Operator.Or
                        ? MaskingRuleClause.Or
                        : MaskingRuleClause.And
                })}
              </div>
            )
          })}
        </>
      </DisplayLogicSummaryBox>

      {open && (
        <DialogScreenerDisplayLogic
          open={open}
          questionLabel={label}
          isTargeting={isTargeting}
          draft={draft}
          questions={questions}
          onSave={onSave}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}

export default DisplayLogicSummary
